import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6877e2d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lt-sm f mb-4" }
const _hoisted_2 = { class: "f-1" }
const _hoisted_3 = { class: "player f-row-2 f-start-center" }
const _hoisted_4 = { class: "h-100 f f-center-start" }
const _hoisted_5 = { class: "t-smaller" }
const _hoisted_6 = { class: "t-small" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "h-100 f-row-2 f-center-center"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-plus" })
], -1))
const _hoisted_10 = { class: "t-small" }
const _hoisted_11 = { class: "mb-1" }
const _hoisted_12 = { class: "mb-2 t-small" }
const _hoisted_13 = { class: "mb-1 t-small" }
const _hoisted_14 = { class: "mb-1" }
const _hoisted_15 = { class: "mb-2 t-small" }

import { computed } from "vue";
import { useStore } from "vuex";
import { t } from "@/helpers/i18n";
import { ws } from "@/helpers/ws";


export default /*#__PURE__*/_defineComponent({
  __name: 'PlayLobbyPlayers',
  props: {
    close: Function,
},
  setup(__props) {

const store = useStore();



const isOwner = computed(() => room.value.owner === room.value.username);

const room = computed(() => store.getters.room);

const freePlayerSlotsCount = computed(
    () => room.value.maxPlayerCount - Object.keys(room.value.players).length
);

function copyInviteLink() {
    if (!isOwner.value) return;
    store.dispatch("addToast", {
        type: "success",
        message: t.play.lobby.invitePlayerToast,
    });
    navigator.clipboard.writeText(`${location.origin}/i/${room.value.id}`);
}

function kick(username: string) {
    ws.kick(username);
}

return (_ctx: any,_cache: any) => {
  const _component_SimpleButton = _resolveComponent("SimpleButton")!
  const _component_SimpleAvatar = _resolveComponent("SimpleAvatar")!
  const _component_RoundIcon = _resolveComponent("RoundIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_SimpleButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.close!())),
        text: _ctx.$t.home.goBack,
        isSmall: ""
      }, null, 8, ["text"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(room).players, (player, key, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "player__wrapper",
          style: _normalizeStyle(`--nth: 0.${index}s`),
          key: player.username
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_SimpleAvatar, { height: "1.5rem" }),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(player.username === _unref(room).owner
                                ? _ctx.$t.play.lobby.host
                                : _ctx.$t.play.lobby.player), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(player.username), 1)
            ]),
            (_unref(isOwner) && player.username !== _unref(room).username)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "player__kick",
                  onClick: ($event: any) => (kick(player.username))
                }, [
                  _createVNode(_component_RoundIcon, { icon: "xmark" })
                ], 8, _hoisted_7))
              : _createCommentVNode("", true)
          ])
        ], 4))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(freePlayerSlotsCount), (slot) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "player-slot",
          style: _normalizeStyle(`--nth: 0.${
                _unref(room).maxPlayerCount - 1 - _unref(freePlayerSlotsCount) + slot
            }s`),
          key: _unref(freePlayerSlotsCount) - slot,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (copyInviteLink()))
        }, [
          (_unref(room).owner === _unref(room).username)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t.play.lobby.invitePlayer), 1)
              ]))
            : _createCommentVNode("", true)
        ], 4))
      }), 128)),
      (_unref(room).maxPlayerCount === 2 && _unref(isOwner))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle(`--nth: 0.${_unref(room).maxPlayerCount}s`),
            class: "f f-center-center shop shop-sign-up"
          }, [
            _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t.play.lobby.signIn), 1),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t.play.lobby.signUpCaption), 1),
            _createVNode(_component_SimpleButton, {
              isFull: "",
              class: "mb-1",
              to: "/sign-in",
              isSmall: "",
              text: _ctx.$t.play.lobby.signIn
            }, null, 8, ["text"]),
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t.common.or), 1),
            _createVNode(_component_SimpleButton, {
              isFull: "",
              to: "/sign-up",
              isSmall: "",
              text: _ctx.$t.play.lobby.signUp
            }, null, 8, ["text"])
          ], 4))
        : _createCommentVNode("", true),
      (_unref(room).maxPlayerCount === 4 && _unref(isOwner))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            style: _normalizeStyle(`--nth: 0.${_unref(room).maxPlayerCount}s`),
            class: "f f f-center-center shop shop-pro"
          }, [
            _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.$t.play.lobby.becomePro), 1),
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t.play.lobby.becomeProCaption), 1),
            _createVNode(_component_SimpleButton, {
              isFull: "",
              to: "/shop",
              isSmall: "",
              text: _ctx.$t.play.lobby.shop
            }, null, 8, ["text"])
          ], 4))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})